/* =========================================================
   PAS · Cart reward  (snippets/cart-reward.liquid)

   Both pieces below are custom elements, not an inline <script> inside
   the snippet. That matters: every time the cart changes the theme
   replaces #minicart-form with a re-rendered copy, and a browser never
   runs the <script> tags that arrive inside innerHTML. A custom element
   upgrades whenever the markup lands in the DOM, so the Add button and
   the unlock animation keep working after every cart change.
   ========================================================= */
(function () {
  'use strict';

  var FLAG = 'pas_cr_unlocked';

  function readFlag() {
    try {
      return window.sessionStorage.getItem(FLAG) === '1';
    } catch (e) {
      return false;
    }
  }
  function setFlag() {
    try {
      window.sessionStorage.setItem(FLAG, '1');
    } catch (e) {}
  }
  function clearFlag() {
    try {
      window.sessionStorage.removeItem(FLAG);
    } catch (e) {}
  }

  /* Keep the rest of the page in step with the cart — the counters in the
     header, the cart drawer subtotal side panel and the free shipping bar.
     Mirrors what the theme itself does after an add to cart. */
  function syncCart(cart) {
    if (!cart || cart.item_count === undefined) return;
    try {
      if (typeof pasSetCartCountBadges === 'function') {
        pasSetCartCountBadges(cart);
      } else {
        var count = 0;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          var it = items[i] || {};
          var typ = String(it.product_type || '').toUpperCase();
          var handle = String(it.handle || '');
          if (typ === 'PPLR_HIDDEN_PRODUCT' || handle === 'item-personalization') continue;
          count += parseInt(it.quantity, 10) || 0;
        }
        var counters = document.querySelectorAll('.cart-count');
        for (var j = 0; j < counters.length; j++) {
          var el = counters[j];
          el.innerHTML = el.classList.contains('cart-count-drawer')
            ? '(' + count + ')'
            : count > 100
              ? '~'
              : String(count);
        }
      }
      var headerPrice = document.querySelector('header-total-price');
      if (headerPrice && typeof headerPrice.updateTotal === 'function') {
        headerPrice.updateTotal(cart);
      }
      var shipBar = document.querySelector('free-ship-progress-bar');
      if (shipBar && typeof shipBar.init === 'function') {
        shipBar.init(cart.items_subtotal_price);
      }
    } catch (e) {}
  }

  function cartJson() {
    return fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  class PasCartReward extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pasReady === '1') return;
      this.dataset.pasReady = '1';

      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);

      /* The server prints the right state, but the drawer is not always
         re-rendered after a change made by hand (removing the reward line,
         changing a quantity). Check the live cart too, and keep watching it,
         so the card never stays stuck on "Added to your cart". */
      this.verify();
      this.watch();

      if (this.getAttribute('data-unlocked') === '1') this.celebrate();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.verifyTimer) {
        clearTimeout(this.verifyTimer);
        this.verifyTimer = null;
      }
    }

    /* Re-check whenever the cart markup around us changes. Attribute-only
       changes (the class / hidden flag this writes) do not retrigger it. */
    watch() {
      var host = this.parentElement;
      if (!host || typeof MutationObserver !== 'function') return;
      var el = this;
      this.observer = new MutationObserver(function () {
        if (el.verifyTimer) clearTimeout(el.verifyTimer);
        el.verifyTimer = setTimeout(function () {
          el.verifyTimer = null;
          el.verify();
        }, 250);
      });
      this.observer.observe(host, { childList: true, subtree: true });
    }

    verify() {
      var el = this;
      var variant = parseInt(this.getAttribute('data-variant'), 10);
      var threshold = parseInt(this.getAttribute('data-threshold'), 10) || 0;
      if (!variant) return Promise.resolve();

      return cartJson()
        .then(function (cart) {
          if (!cart) return;
          var subtotal = cart.items_subtotal_price || 0;

          /* Under the threshold again: the block is not offered at all. */
          if (threshold > 0 && subtotal < threshold) {
            el.hidden = true;
            return;
          }
          el.hidden = false;

          var items = cart.items || [];
          var inCart = false;
          for (var i = 0; i < items.length; i++) {
            if (parseInt(items[i].variant_id, 10) === variant) {
              inCart = true;
              break;
            }
          }
          /* Already in the cart → say nothing. The reward line in the item
             list is the confirmation; a second bar repeating it is noise. */
          el.classList.toggle('is-added', inCart);
          if (inCart) el.hidden = true;
        })
        .catch(function () {});
    }

    handleClick(event) {
      var btn = event.target.closest ? event.target.closest('[data-pas-cr-add]') : null;
      if (!btn || !this.contains(btn)) return;
      event.preventDefault();
      this.add();
    }

    /* The once-per-session reveal. Adding the class in the same frame the
       element was inserted makes the browser paint the end state straight
       away and the animation never plays, hence the two frames wait. */
    celebrate() {
      if (!this.hasAttribute('data-celebrate')) return;
      if (this.classList.contains('is-added')) return;
      if (readFlag()) return;
      var el = this;
      setFlag();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('is-celebrate');
        });
      });
    }

    add() {
      if (this.dataset.busy === '1') return;
      var id = parseInt(this.getAttribute('data-variant'), 10);
      if (!id) return;

      var el = this;
      el.dataset.busy = '1';
      el.classList.add('is-busy');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
        .then(function () {
          el.classList.add('is-added');
          el.hidden = true;
          el.refresh();
        })
        .catch(function () {
          el.dataset.busy = '0';
          el.classList.remove('is-busy');
          window.location.reload();
        });
    }

    refresh() {
      var place = this.getAttribute('data-place') || 'drawer';
      var form = document.getElementById('minicart-form');

      if (place === 'drawer' && form) {
        var url = (this.getAttribute('data-cart-url') || '/cart') + '?section_id=minicart-form';
        fetch(url, { cache: 'no-store' })
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var next = new DOMParser().parseFromString(html, 'text/html').querySelector('#minicart-form');
            if (!next) {
              window.location.reload();
              return;
            }
            form.innerHTML = next.innerHTML;
            return cartJson().then(syncCart);
          })
          .catch(function () {
            window.location.reload();
          });
        return;
      }

      window.location.reload();
    }
  }

  /* Printed whenever the card is not on screen: under the threshold, or the
     reward already in the cart. Resets the once-per-session flag so the reveal
     can play again next time, and — only when the offer has stopped applying
     and that setting is on — takes the reward back out of the cart. */
  class PasCartRewardState extends HTMLElement {
    connectedCallback() {
      clearFlag();
      this.takeBack();
    }

    /* Everything here is a delete call, so it gets two gates:
         1. the server only sets data-remove when the offer no longer applies;
         2. this re-reads /cart.js and backs out if the cart is still over the
            threshold.
       Gate 2 is not paranoia: a marker can be rendered for a cart that has
       already moved on (a stale drawer render, or a page left open in a second
       tab). Deleting a line the shopper added on purpose is far worse than
       leaving a full-price reward for them to remove by hand. */
    takeBack() {
      if (this.getAttribute('data-remove') !== '1') return;
      var key = this.getAttribute('data-line-key');
      if (!key || window.pasCrRemoving) return;

      var threshold = parseInt(this.getAttribute('data-threshold'), 10) || 0;
      var el = this;
      window.pasCrRemoving = true;

      cartJson()
        .then(function (cart) {
          if (!cart) return null;
          var subtotal = cart.items_subtotal_price || 0;
          if (threshold > 0 && subtotal >= threshold) return null;

          var stillThere = false;
          var items = cart.items || [];
          for (var i = 0; i < items.length; i++) {
            if (items[i].key === key) {
              stillThere = true;
              break;
            }
          }
          if (!stillThere) return null;

          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          }).then(function (r) {
            return r.json();
          });
        })
        .then(function (result) {
          if (result === null) {
            window.pasCrRemoving = false;
            return;
          }
          window.location.reload();
        })
        .catch(function () {
          window.pasCrRemoving = false;
          el.hidden = true;
        });
    }
  }

  if (!customElements.get('pas-cart-reward')) customElements.define('pas-cart-reward', PasCartReward);
  if (!customElements.get('pas-cart-reward-state')) {
    customElements.define('pas-cart-reward-state', PasCartRewardState);
  }
})();
